import { useEffect, useState } from 'react';
import { useGetMaterialCost } from '../api/get-material-cost';
import { Field, Panel } from '../../../../layouts';
import DateBox from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import { useGetMaterialCostFilterData } from '../api/get-material-cost-filter-data';
import Box, { Item } from 'devextreme-react/box';
import { Item as ToolbarItem, Toolbar } from 'devextreme-react/toolbar';
import { Button } from "devextreme-react/button";
import { RequiredRule, Validator } from "devextreme-react/validator";
import { Item as TabPanelItem, TabPanel } from 'devextreme-react/tab-panel';
import './MaterialCostSearch.scss'
import MaterialCostGrid from './MaterialCostGrid';
import { LoadPagePanel } from '../../../../components';

export default function MaterialCostSearch() {

	const filterData = useGetMaterialCostFilterData();

	const [date, setDate] = useState(new Date());
	const [salesChannelID, setSalesChannel] = useState<number | undefined>();
	const [productLineID, setProductLine] = useState<number | undefined>();
	const [prodQteGrpID, setProductGroup] = useState<number | undefined>();

	useEffect(() => {

		if (filterData.data) {
			if (filterData.data.salesChannels?.length > 0)
				setSalesChannel(filterData.data.salesChannels[0].salesChannelID);

			if (filterData.data.productLines?.length > 0)
				setProductLine(filterData.data.productLines[0].productLineID);

			setProductGroup(filterData.data.productGroups.find(x => x.productLineID === productLineID)?.prodQteGrpID);
		}
	}, [filterData.data]);

	const materialCost = useGetMaterialCost({ date, salesChannelID, productLineID, prodQteGrpID });

	return (
		<>
			<Box className='material-cost-filter'>
				<Item ratio={1}>
					<Panel header="Material Cost Filter">
						<Field label='Date'>
							<DateBox
								showClearButton={false}
								value={date}
								onValueChanged={(e) => setDate(e.value)}
							>
								<Validator validationGroup='materialCostValidationGroup'>
									<RequiredRule />
								</Validator>
							</DateBox>
						</Field>
						<Field label='Sales Channel'>
							<SelectBox
								value={salesChannelID}
								onValueChanged={(e) => setSalesChannel(e.value)}
								dataSource={filterData.data?.salesChannels}
								valueExpr="salesChannelID"
								displayExpr="salesChannelName"
							>
								<Validator validationGroup='materialCostValidationGroup'>
									<RequiredRule />
								</Validator>
							</SelectBox>
						</Field>
						<Field label='Product Line'>
							<SelectBox
								value={productLineID}
								onValueChanged={(e) => {
									setProductLine(e.value);
									setProductGroup(filterData.data?.productGroups.find(x => x.productLineID === e.value)?.prodQteGrpID);
								}}
								dataSource={filterData.data?.productLines}
								valueExpr="productLineID"
								displayExpr="description"
							>
								<Validator validationGroup='materialCostValidationGroup'>
									<RequiredRule />
								</Validator>
							</SelectBox>
						</Field>
						<Field label='Product Group'>
							<SelectBox
								value={prodQteGrpID}
								onValueChanged={(e) => setProductGroup(e.value)}
								dataSource={filterData.data?.productGroups.filter(x => x.productLineID === productLineID)}
								valueExpr="prodQteGrpID"
								displayExpr="description"
							>
								<Validator validationGroup='materialCostValidationGroup'>
									<RequiredRule />
								</Validator>
							</SelectBox>
						</Field>
						<Toolbar className='button-toolbar'>
							<ToolbarItem location='after'>
								<Button
									text="Search"
									className="save-button"
									validationGroup='materialCostValidationGroup'
									onClick={(e) => {
										if (e.validationGroup.validate().isValid) {
											materialCost.refetch();
										}
									}}>
								</Button>
							</ToolbarItem>
						</Toolbar>
					</Panel>
				</Item>
				<Item ratio={1}>
				</Item>
				<Item ratio={1}>
				</Item>
			</Box>
			<TabPanel visible={!!materialCost.data} className="dx-card wide-card">
				<TabPanelItem title="Standard">
					<MaterialCostGrid records={materialCost.data?.standard ?? []}
						reportParams={{
							date: date,
							salesChannelID: salesChannelID,
							productLineID: productLineID,
							prodQteGrpID: prodQteGrpID,
							isPromo: false
						}} />
				</TabPanelItem>
				<TabPanelItem title="Promo">
					<MaterialCostGrid records={materialCost.data?.promo ?? []}
						reportParams={{
							date: date,
							salesChannelID: salesChannelID,
							productLineID: productLineID,
							prodQteGrpID: prodQteGrpID,
							isPromo: true
						}} />
				</TabPanelItem>
			</TabPanel>

			<LoadPagePanel visible={filterData.isLoading || materialCost.isLoading} />
		</>
	)
} 
